import { Button, ButtonProps, Group, Modal, Stack, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconTrash as IconDelete } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface DeleteButtonProps extends ButtonProps {
  onDelete: () => Promise<void> | Promise<unknown>;
  isDeleting?: boolean;
}

export function DeleteButton(props: DeleteButtonProps) {
  const { onDelete, isDeleting, ...buttonProps } = props;
  const { t } = useTranslation();
  const [opened, { open, close }] = useDisclosure(false);
  const handleDelete = () => {
    onDelete().then(close);
  };

  return (
    <>
      <Button
        {...buttonProps}
        onClick={open}
        bg="red"
        leftSection={<IconDelete size={16} />}
      >
        {t('button.delete')}
      </Button>
      <Modal
        opened={opened}
        onClose={close}
        title={t('deleteConfirm.title')}
        centered
      >
        <Stack>
          <Text
            style={{ textAlign: 'center' }}
            fw="500"
          >
            {t('deleteConfirm.content')}
          </Text>
          <Group justify="flex-end">
            <Button
              variant="outline"
              onClick={close}
              loading={isDeleting}
            >
              {t('button.cancel')}
            </Button>
            <Button
              onClick={handleDelete}
              bg="red"
              loading={isDeleting}
              leftSection={<IconDelete size={16} />}
            >
              {t('button.delete')}
            </Button>
          </Group>
        </Stack>
      </Modal>
    </>
  );
}
